import { db } from "../../server";
import { instance } from "../apiclient";
import { interpolate } from "../helpers/stringHelper";
import { paths } from "../constants/dbPaths";
import { DetectBrand } from "../../mixins/brandDetector";

import { auth } from "../../server/index.js";
var HQCompanyID = "1";
export function getDBUser(id) {
  return db.doc(interpolate(paths.UserDoc, id));
}
export function updateUser(id, data) {
  return db.doc(interpolate(paths.UserDoc, id)).set(data, {
    merge: true
  });
}
export async function storeCard(userId, card, errorhandler) {
  var md = {
    HQCompanyID: HQCompanyID, //"2016949",
    CardHolder: card.holder,
    CardNumber: card.number,
    ExpiryYear: card.expYear,
    ExpiryMonth: card.expMonth,
    Cvv: card.cvv,
    ForceUseSandboxPayment: true
  };
  return instance.post("customers/" + userId + "/storecard", md).catch(e => {
    if (errorhandler) errorhandler(e.message);
  });
}
export function deleteCard(userId, cardIdentifier) {
  var md = {
    HQCompanyID: HQCompanyID
  };
  return instance.delete(
    "customers/" + userId + "/storecard/" + cardIdentifier,
    {
      model: md,
      userId: userId,
      cardIdentifier: cardIdentifier
    }
  );
}
export function OrderCount(userId) {
  return db.collection(interpolate(paths.HistoryOrdersCollection, userId));
}

export function getOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("CreatedOn", "desc");
  }
}

export function getTrackingOrders(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, userId))
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.TrackingOrderCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .orderBy("CreatedOn", "desc");
  }
}

export function getOrdersLoyalty(userId, StoreID) {
  var isBranded = DetectBrand.methods.isBranded();
  if (isBranded) {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, userId))
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  } else {
    return db
      .collection(interpolate(paths.HistoryOrdersCollection, StoreID))
      .where("OnlineOrderUserIdentifier", "==", userId)
      .where("RewardPoints", ">=", 0)
      .orderBy("RewardPoints", "desc")
      .orderBy("CreatedOn", "desc");
  }
}

export async function RegisterCustomer(udid, userInfo) {
  const customer = {
    DisplayName: userInfo.FirstName + " " + userInfo.LastName,
    FirstName: userInfo.FirstName,
    LastName: userInfo.LastName,
    Email: userInfo.email,
    HQCompanyID: HQCompanyID
  };
  return instance.post("/customers/" + udid, customer);
}

export async function signInWithPassword(email, password) {
  return auth.signInWithEmailAndPassword(email, password);
}
export async function signOut() {
  return auth.signOut();
}
export async function getGuestUser(StoreID, guestUserId) {
  var isBranded = DetectBrand.methods.isBranded();
  if (!isBranded) {
    return db
      .collection(paths.GuestUserDoc)
      .doc(guestUserId)
      .get();
  } else {
    return db
      .collection(interpolate(paths.GuestUserDoc, StoreID))
      .doc(guestUserId)
      .get();
  }
}
export async function sendResetPasswordLink(email, storeId) {
  const resetPasswordInfo = {
    Email: email,
    Company_ID: storeId
  };
  return instance.post("/customers/reset-password-api", resetPasswordInfo);
}
export async function resetUserPassword(userDoc) {
  return auth.currentUser.updatePassword(userDoc.Password);
}

export async function userIsExist(email) {
  return auth.fetchSignInMethodsForEmail(email);
}
